<!-- Title -->
<h5 mat-dialog-title>
  {{ confirmationData.title ?? 'common.warning' | translate | titlecase }}
</h5>

<!-- Content -->
<mat-dialog-content>
  <p>{{ confirmationData.message ?? 'common.confirmation' | translate }}</p>

  <div *ngIf="showTextbox" class="show-text-box">
    <form class="dialog-form" [formGroup]="rejectForm">
      <!-- Row 1 -->
      <!-- Rejection Reason -->
      <div class="p-field">
        <span class="p-float-label required">
          <textarea
            pInputTextarea
            formControlName="reason"
            [rows]="3"
            [autoResize]="true"
          ></textarea>
          <label>{{ 'common.reason' | translate }}</label>
        </span>
        <app-validation-error
          [control]="rejectForm.get(['reason'])"
          [field]="'common.reason' | translate"
        ></app-validation-error>
      </div>
    </form>
  </div>

  <div
    class="dialog-actions"
    fxLayout="row"
    fxLayout.lt-md="column"
    fxLayoutGap="15px"
    fxLayoutAlign="center"
    fxLayoutAlign.lt-md="center center"
  >
    <!-- Confirm Button -->
    <button
      mat-flat-button
      color="accent"
      [mat-dialog-close]="showTextbox ? rejectForm.get('reason')?.value : true"
      [disabled]="showTextbox ? rejectForm.invalid : false"
      *ngIf="showConfirmButton"
    >
      {{ confirmationData.confirmButtonText ?? 'common.confirm' | translate | titlecase }}
    </button>

    <!-- Cancel -->
    <button class="cancel" mat-flat-button [mat-dialog-close]="false">
      {{ confirmationData.cancelButtonText ?? 'common.cancel' | translate | titlecase }}
    </button>
  </div>
</mat-dialog-content>
